/**
 * Entry point for the Products & Services page.
 *
 * No 3D layer here — this page is a document, not a scene. It shares the brand
 * palette and shared components from site.css and adds its own denser layout.
 * The only behaviour is the entrance reveals, and even those fail open.
 */

import './styles/site.css';
import './styles/services.css';
import { initReveals } from './core/reveal.js';

initReveals();
